/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// May contain unused imports in some cases
// @ts-ignore
import { SuccessCardTransactionCardTransactionTransactionRecordListInner } from './success-card-transaction-card-transaction-transaction-record-list-inner';

/**
 * 
 * @export
 * @interface SuccessCardTransactionCardTransaction
 */
export interface SuccessCardTransactionCardTransaction {
    /**
     * 
     * @type {string}
     * @memberof SuccessCardTransactionCardTransaction
     */
    'visaTransactionReferenceId': string;
    /**
     * 
     * @type {string}
     * @memberof SuccessCardTransactionCardTransaction
     */
    'paymentReferenceId': string;
    /**
     * 
     * @type {string}
     * @memberof SuccessCardTransactionCardTransaction
     */
    'merchantName': string;
    /**
     * 
     * @type {string}
     * @memberof SuccessCardTransactionCardTransaction
     */
    'merchantNameKana': string;
    /**
     * 
     * @type {string}
     * @memberof SuccessCardTransactionCardTransaction
     */
    'merchantNameKanji': string;
    /**
     * 
     * @type {string}
     * @memberof SuccessCardTransactionCardTransaction
     */
    'mergedMerchantName': string;
    /**
     * 
     * @type {number}
     * @memberof SuccessCardTransactionCardTransaction
     */
    'amount': number;
    /**
     * 
     * @type {number}
     * @memberof SuccessCardTransactionCardTransaction
     */
    'amountFx': number;
    /**
     * 
     * @type {string}
     * @memberof SuccessCardTransactionCardTransaction
     */
    'currencyCode': string;
    /**
     * 
     * @type {string}
     * @memberof SuccessCardTransactionCardTransaction
     */
    'processedAt': string;
    /**
     * 
     * @type {string}
     * @memberof SuccessCardTransactionCardTransaction
     */
    'transactionType': SuccessCardTransactionCardTransactionTransactionTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof SuccessCardTransactionCardTransaction
     */
    'transactionStatus': SuccessCardTransactionCardTransactionTransactionStatusEnum;
    /**
     * 
     * @type {number}
     * @memberof SuccessCardTransactionCardTransaction
     */
    'creditSettlement': number;
    /**
     * 
     * @type {Array<SuccessCardTransactionCardTransactionTransactionRecordListInner>}
     * @memberof SuccessCardTransactionCardTransaction
     */
    'transactionRecordList': Array<SuccessCardTransactionCardTransactionTransactionRecordListInner>;
    /**
     * 
     * @type {boolean}
     * @memberof SuccessCardTransactionCardTransaction
     */
    'isCleared': boolean;
}

export const SuccessCardTransactionCardTransactionTransactionTypeEnum = {
    confirm: 'CONFIRM',
    notConfirm: 'NOT_CONFIRM'
} as const;

export type SuccessCardTransactionCardTransactionTransactionTypeEnum = typeof SuccessCardTransactionCardTransactionTransactionTypeEnum[keyof typeof SuccessCardTransactionCardTransactionTransactionTypeEnum];
export const SuccessCardTransactionCardTransactionTransactionStatusEnum = {
    success: 'SUCCESS'
} as const;

export type SuccessCardTransactionCardTransactionTransactionStatusEnum = typeof SuccessCardTransactionCardTransactionTransactionStatusEnum[keyof typeof SuccessCardTransactionCardTransactionTransactionStatusEnum];


